export default __webpack_public_path__ + "static/media/main_top_2.e10020e6.jpg";